<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span v-if="isEdit">{{ $t('message.editCashier') }}</span>
        <span v-else>{{ $t('message.addCashier') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="form.valid">
          <v-container grid-list-md pt-0>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-text-field
                  :label="$t('message.name')"
                  data-vv-name="name"
                  prepend-icon="label"
                  :error-messages="errors.collect('name')"
                  v-validate="'required'"
                  v-model="form.name"
                  type="text"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex md12 xs12>
                <v-text-field
                  :label="$t('message.lastname')"
                  data-vv-name="lastname"
                  prepend-icon="label"
                  :error-messages="errors.collect('lastname')"
                  v-validate="'required'"
                  v-model="form.lastname"
                  type="text"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex md12 xs12>
                <v-text-field
                  :label="$t('message.email')"
                  data-vv-name="email"
                  prepend-icon="zmdi-email"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  v-model="form.email"
                  type="text"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="!isCreate">
                <v-switch
                  :label="form.status_id == 1 ? $t('message.enabled') : $t('message.disabled')"
                  v-model="form.status_id"
                  color="primary"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CASHIERS } from "../../store/modules/cashiers/actions.type";

const initForm = {
  name: "",
  lastname: "",
  email: "",
  status_id: null,
  valid: false
};

export default {
  name: "cashierManage",
  props: {
    dialog: {
      required: false,
      default: false
    },
    isCreate: {
      required: false,
      default: false
    },
    isEdit: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      form: initForm,
      dialogModel: this.dialog,
    };
  },
  methods: {
    resetForm() {
      this.form = initForm
      this.$validator.reset()
      this.$refs.form.reset()
    },
    onClose() {
      this.$emit("update:dialog", false)
      this.resetForm()
    },
    setValue(cashier) {
      this.form.name = cashier.name
      this.form.lastname = cashier.lastname
      this.form.email = cashier.email
      // Gracias Yen por hacerme hacer esta cochinada
      this.form.status_id = cashier.status_id === 1 ? true : false
    },
    setStatus() {
      this.form.status_id = this.form.status_id === true ? 1 : 2
    },
    async onSave() {
      try {
        const valid = await this.$validator.validateAll()
        if (valid) {
          this.setStatus()
          this.$emit("on-save", this.form)
          this.$emit("update:dialog", false)
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch:{
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit('update:dialog', value);
    }
  }
};
</script>

<style>
</style>
